import api from "../utils/api";
import { AxiosResponse } from "axios";
import { CreateInternalProjectDto, InternalProjectDto } from "../types/traineesTypes";

/**
 * Get a specific internal project by ID
 * @param internalProjectId - The ID of the internal project
 * @returns The internal project of type InternalProjectDto
 */
export const getIP = async (internalProjectId: number): Promise<AxiosResponse<InternalProjectDto>> => {
  return await api.get<InternalProjectDto>(`/trainees/ip/${internalProjectId}`);
};

/**
 * Get the current internal projects
 * @returns An array of current internal projects of type InternalProjectDto
 */
export const getCurrentIPs = async (): Promise<AxiosResponse<InternalProjectDto[]>> => {
  return await api.get<InternalProjectDto[]>(`/trainees/ips/current`);
};

/**
 * Get all internal projects
 * @returns An array of all internal projects of type InternalProjectDto
 */
export const getAllIPs = async (): Promise<AxiosResponse<InternalProjectDto[]>> => {
  return await api.get<InternalProjectDto[]>(`/trainees/ips/all`);
};

//-----------------------------------------------------------------------------------------------------------------------
// UPDATE ROUTES

/**
 * Update the an internal project
 * @param internalProject - The internal project
 * @returns The updated internal project of type InternalProjectDto
 */
export const updateIP = async (internalProject: InternalProjectDto): Promise<AxiosResponse<InternalProjectDto>> => {
  return await api.put<InternalProjectDto>(`/trainees/ip/${internalProject.internalProjectId}`, internalProject);
};

/**
 * Create an internal project
 * @param internalProjectData - The internal project data
 * @returns void
 */
export const createIP = async (internalProjectData: CreateInternalProjectDto): Promise<void> => {
  return await api.post("trainees/ips", internalProjectData);
};

/**
 * Delete an internal project by id
 * @param internalProjectId - The ID of the internal project to delete
 * @returns void
 */
export const deleteIP = async (internalProjectId: number): Promise<void> => {
  return await api.delete(`trainees/ip/${internalProjectId}`);
};
